import { useContext } from 'react';

import { cmnContext } from '../../../../../../common/CmnContext';
import { LiveReserveContext } from '../../../LiveLessonReseveContext';
import Modal from '../../../../../../common/Modal';


/**
 * 講師の詳細（プロフィール／レビュー） (SPEAKOUT-1853)
 *
 * 講師選択の一覧からは名前と写真・趣味の抜粋しか分からず、「この講師でいいか」を
 * 判断する材料が足りなかった。講師紹介ページ(/lesson/instructor/profile)には
 * プロフィールとレビューが揃っているので、それを iframe でそのまま見せる。
 *
 * ★中身は React で作り直さない。同じ内容を2箇所で持つと必ず食い違う。
 * ★`?embed=1` … ナビ・左メニュー・フッター・計測タグと、埋め込み元と重複する
 *   ボタン群（予約する／講師リクエスト）を出さない埋め込み専用の表示。
 *   実装は SPEAKOUT-1799（My Teacher申込ページ）が入れたものをそのまま使っている。
 * 🔴 計測タグを外すのは体裁の話ではない。あれは async でも defer でもない同期スクリプトで、
 *   外部ホストが遅いと iframe が真っ白のまま load も発火しない（1799 で実際に踏んだ）。
 */
function LiveReserveInstructorDetail() {

  const isPc = useContext(cmnContext).isPc;
  const {
    detailInstId, setDetailInstId,
    instructors, noSlotInstructors,
  } = useContext(LiveReserveContext);

  // 空き枠の無い講師も一覧に出るので、名前は両方から探す
  const allInstructors = (instructors || []).concat(noSlotInstructors || []);
  const inst = allInstructors.find((item: any) => item.inst_id == detailInstId);


  return (
    <Modal
      comp={
        <div style={{backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden'}}>
          <div style={{padding: '10px', borderBottom: '1px solid #ddd'}}>
            <h4 className="modal-title text-center" style={{margin: 0, fontWeight: 'bold'}}>
              {inst ? inst.name + ' 講師' : '講師紹介'}
            </h4>
          </div>
          {detailInstId &&
            <iframe
              title="講師紹介"
              src={'/lesson/instructor/profile?embed=1&inst_id=' + detailInstId}
              style={{
                display: 'block',
                width: '100%',
                height: isPc ? '65vh' : '60vh',
                border: 'none',
              }}
            />
          }
        </div>
      }
      isDispModal={Boolean(detailInstId)}
      setIsDispModal={() => setDetailInstId(null)}
      modalWidth={isPc? '80%' : '95%'}
      isDispClose={true}
    />
  );
}

export default LiveReserveInstructorDetail;
